import { inject, NgModule } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  CanActivateFn,
  PreloadAllModules,
  RouterModule,
  RouterStateSnapshot,
  Routes,
} from '@angular/router';
import { AuthGuardService } from './services/security/auth-guard.service';
import { SuperAdminGuardService } from './services/security/super-admin-guard.service';
import { TestUiGuardService } from './services/security/test-ui-guard.service';

const canActivateLogin: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(AuthGuardService).canActivateLogin(route);
};

const canActivateWithUser: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(AuthGuardService).canActivate(state);
};
const canActivateWithOrg: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(AuthGuardService).canActivateWithOrganization(state);
};

const canActivateChildWithOrg: CanActivateChildFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(AuthGuardService).canActivateWithOrganization(state);
};

const canActivateSuperAdmin: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(SuperAdminGuardService).canActivate(state);
};

const canActivateTestUi: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(TestUiGuardService).canActivate(state);
};

const canActivateChildSuperAdmin: CanActivateChildFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(SuperAdminGuardService).canActivateChild(route, state);
};

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./tabs/tabs.routes').then((m) => m.routes),
    canActivate: [canActivateWithOrg],
    canActivateChild: [canActivateChildWithOrg],
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.page').then((m) => m.LoginPage),
    canActivate: [canActivateLogin],
  },
  {
    path: 'org-selection',
    loadComponent: () =>
      import('./org-selection/org-selection.page').then(
        (m) => m.OrgSelectionPage
      ),
    canActivate: [canActivateWithUser],
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
    canActivate: [canActivateSuperAdmin],
    canActivateChild: [canActivateChildSuperAdmin],
  },
  {
    path: 'dev-tools',
    loadComponent: () =>
      import('./dev-tools/test-data-generator.component').then(
        (m) => m.default
      ),
    // Test-UI: nur Super-Admins, lokal (!environment.production) offen (#924)
    canActivate: [canActivateTestUi],
  },
  {
    path: 'auth/callback',
    redirectTo: 'login',
  },
  {
    path: '**',
    loadChildren: () =>
      import('./not-found/not-found.routes').then((m) => m.routes),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
